import { MGPOptional } from '@everyboard/lib';
import { NumberConfig } from '../../../config/NumberConfig';
import { RulesConfigDescription } from '../../../config/RulesConfigDescription';
import { RulesConfigDescriptionLocalizable } from '../../../config/RulesConfigDescriptionLocalizable';
import { PlayerNumberMap } from '../../../jscaip/PlayerMap';
import { TableUtils } from '../../../jscaip/TableUtils';
import { MGPValidators } from '../../../utils/MGPValidator';
import { AbstractGoRules } from '../AbstractGoRules';
import { HexagonalGoGroupDataFactory } from '../GoGroupDataFactory';
import { GoPhase } from '../GoPhase';
import { GoPiece } from '../GoPiece';
import { GoState } from '../GoState';
export class HexagonalGoRules extends AbstractGoRules {
    static singleton = MGPOptional.empty();
    static RULES_CONFIG_DESCRIPTION = new RulesConfigDescription({
        name: () => $localize `Standard`,
        config: {
            size: new NumberConfig(7, RulesConfigDescriptionLocalizable.SIZE, MGPValidators.range(1, 99)),
        },
    });
    static get() {
        if (HexagonalGoRules.singleton.isAbsent()) {
            HexagonalGoRules.singleton = MGPOptional.of(new HexagonalGoRules());
        }
        return HexagonalGoRules.singleton.get();
    }
    constructor() {
        super(false);
    }
    getInitialState(config) {
        const size = config.size;
        const boardSize = (size * 2) - 1;
        const maximumDiagonalIndex = (3 * size) - 2;
        const board = TableUtils.create(boardSize, boardSize, GoPiece.UNREACHABLE);
        for (let y = 0; y < boardSize; y++) {
            for (let x = 0; x < boardSize; x++) {
                const diagonalIndex = x + y;
                if (size - 2 < diagonalIndex && diagonalIndex < maximumDiagonalIndex) {
                    board[y][x] = GoPiece.EMPTY;
                }
            }
        }
        return new GoState(board, PlayerNumberMap.of(0, 0), 0, MGPOptional.empty(), GoPhase.PLAYING);
    }
    getRulesConfigDescription() {
        return HexagonalGoRules.RULES_CONFIG_DESCRIPTION;
    }
    getGoGroupDataFactory(_) {
        return new HexagonalGoGroupDataFactory();
    }
}
